
import React, { useEffect, useState } from 'react';
import {withSession} from "../../session";
import {SdfIcon, SdfLink, SdfSpotIllustration, SdfTab, SdfTabGroup} from '@synerg/react-components';
import {showErrorModal, useApplicationState} from "../../../utilities/applicationState";
import axios from "axios";
import get from "lodash/get";

function WhatToExpect({ hasProjects = false }) {
    const [stage, setStage] = useState(0);
    const [, dispatch] = useApplicationState();
    const [ milestoneStages, setStages ] = useState([]);

    const illustrations = {
        'Onboarding' : 'clipboard',
        'Development': 'laptop-code',
        'Go-to-Market Strategy': 'bullhorn',
        'Security Review': 'cloud-shield',
        'Go Live': 'browser-pointer',
    }

    const goNext = () => setStage(stage + 1);
    const goPrev = () => setStage(stage - 1);

    const fetchProjectDuration = async () => {
        try {
            const {data: {stages}} = await axios(`${import.meta.env.VITE_ROOT_PATH}/api/project/stages`);
            setStages(stages);
        } catch (e) {
            const errorMessage = get(e, 'response.data.message', 'Something went wrong when trying to get projects. Please try again.');
            dispatch(showErrorModal(errorMessage));
        }
    };

    useEffect(() => {
        fetchProjectDuration();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <div className="mx-24 my-10 text-heading-06 font-bold">
                {"Here's what you can expect"}
            </div>
            <div className="mx-24 my-10 items-center sm:shadow-16 rounded-2xl overflow-hidden">
                <div className="flex">
                    <div className="order-1 w-4/6 mt-10" style={{height: '450px'}}>
                        <div className="flex flex-col items-center mx-24 my-10 overflow-hidden">
                            <span className="text-heading-06 font-bold">Integrating with ADP</span>
                            <div className="flex flex-col mt-4 text-center">
                                <span className="w-full mt-10 ml-6">
                                        <SdfTabGroup size="default" spacing="loose" className="flex flex-row w-2xl" onSdfChange={(e) => { setStage(e.detail.value) }}>
                                            <section className="flex flex-row">
                                                {milestoneStages.map((cStage, idx) =>  (
                                                    <div key={`stage-details-${idx}`}  className='flex flex-col'>
                                                        {cStage.title.toLowerCase() ===
                                                          "go-to-market strategy" && (
                                                          <SdfTab active={idx === stage} value={idx}>
                                                            <div className="flex flex-col">
                                                              {cStage.title.toLowerCase() ===
                                                                "development" && (
                                                                <SdfSpotIllustration
                                                                  style={{ height: "92.3px" }}
                                                                  illustrationName={
                                                                    illustrations[cStage.title]
                                                                  }
                                                                  size="md"
                                                                ></SdfSpotIllustration>
                                                              )}
                                                              {cStage.title.toLowerCase() !==
                                                                "development" && (
                                                                <SdfSpotIllustration
                                                                  style={{ height: "92.3px" }}
                                                                  illustrationName={
                                                                    illustrations[cStage.title]
                                                                  }
                                                                  size="md"
                                                                ></SdfSpotIllustration>
                                                              )}
                                                              <div className="text-md">GTM Strategy</div>
                                                            </div>
                                                          </SdfTab>
                                                        )}
                                                        {cStage.title.toLowerCase() !==
                                                          "go-to-market strategy" && (
                                                          <SdfTab active={idx === stage} value={idx}>
                                                            <div className="flex flex-col">
                                                              {cStage.title.toLowerCase() ===
                                                                "development" && (
                                                                <SdfSpotIllustration
                                                                  style={{ height: "92.3px" }}
                                                                  illustrationName={
                                                                    illustrations[cStage.title]
                                                                  }
                                                                  size="md"
                                                                ></SdfSpotIllustration>
                                                              )}
                                                              {cStage.title.toLowerCase() !==
                                                                "development" && (
                                                                <SdfSpotIllustration
                                                                  style={{ height: "92.3px" }}
                                                                  illustrationName={
                                                                    illustrations[cStage.title]
                                                                  }
                                                                  size="md"
                                                                ></SdfSpotIllustration>
                                                              )}
                                                              <div className="text-md">{cStage.title}</div>
                                                            </div>
                                                          </SdfTab>
                                                        )}
                                                    </div>
                                                ))}
                                            </section>
                                        </SdfTabGroup>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="order-2 w-2/6 px-8 flex flex-col justify-between" style={{backgroundColor: '#e8effa'}}>
                        <div className='order-1' >
                            {milestoneStages.map((cStage, idx) => (idx === stage &&
                                <div key={`stage-details-${idx}`}>
                                    { cStage.title.toLowerCase() === 'go-to-market strategy' &&
                                        <div className="text-heading-04 font-bold pb-3 mt-6 order-1">Go-To-Market (GTM) Strategy</div>}
                                    { cStage.title.toLowerCase() !== 'go-to-market strategy' &&
                                        <div className="text-heading-04 font-bold pb-3 mt-6 order-1">{cStage.title}</div>}
                                    <div className="text-body-02 order-2">
                                        {cStage.description.map((desc, idx) => <p key={`description-${idx}-${stage}`} dangerouslySetInnerHTML={{__html: desc}}></p>)}
                                    </div>
                                </div>))}
                        </div>
                        <div className={'flex justify-between self-end order-2 mb-10 w-full'}>
                            {stage !== 0 &&
                                <SdfLink onClick={() => goPrev() } className="cursor-pointer outline-none shadow-none">
                                    <SdfIcon icon="nav-move-left" slot=""></SdfIcon> Back
                                </SdfLink>
                            }
                            {stage < milestoneStages.length - 1 &&
                                <SdfLink onClick={() => goNext() } className="cursor-pointer outline-none shadow-none">
                                    Next <SdfIcon icon="nav-move-right" slot=""></SdfIcon>
                                </SdfLink>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default withSession(WhatToExpect);

